import request from 'src/api'
import deleteRecord from 'src/deleteRecord'
import moment from 'moment-timezone' // https://momentjs.com/
import { addToast } from 'src/toasts'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import withDirtyGuard from 'src/dirtyNav'

export default () => {
  $('#offcanvasRight').on('click', '#new', function(event) {
    if ($('#offcanvasRight .tab-pane.active').attr('id') === 'quality-controls') {
      withDirtyGuard(function () {
        lockButton('#new')
        const url = $('#quality-controls-link button').data('link') + '/new'
        $.getScript(url)
      })
    }
  })

  // 📌 `focusin` records what the select held BEFORE the user touched it — it fires ahead of `change`,
  // and there is no other way to know: by the time `change` runs the browser has already moved the value,
  // and the server does not mark which option is loaded.
  $('#offcanvasRight').on('focusin', '#quality-control-select', function() {
    $(this).data('loadedId', $(this).val())
  })

  // ⚠️ **The select is REVERTED before the question is asked, and restored only on Continue.** The browser
  // has already moved it by the time this handler runs, so Cancel would otherwise leave the dropdown
  // naming a control the form is not showing — which is the same confusion the owner reported from the
  // other direction. Keeping `previous` here is why `withDirtyGuard` takes an action rather than a URL.
  $('#offcanvasRight').on('change', '#quality-control-select', function(event) {
    const select = $(this)
    const id = select.val()
    if (!id) return

    const previous = select.data('loadedId')
    if (dirty && previous) select.val(previous)

    withDirtyGuard(function () {
      select.val(id)
      select.data('loadedId', id)
      lockButton('#quality-control-select')
      const customerId = $("#quality-controls-link button").data('link').split('/')[2]
      $.getScript('/customers/' + customerId + '/quality_controls/' + id + '/edit')
    })
  })

  $('#offcanvasRight').on('click', '.add_contact_person_quality_control', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $(this).closest('form').find('.contact_person_quality_controls_rows').append($(this).data('fields').replace(regexp, time))

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '.remove_quality_control_contact_person_row', function(event) {
    $(this).closest('.contact_person_quality_controls_row').find('input[name*="_destroy"]').first().val('1')
    $(this).closest('.contact_person_quality_controls_row').addClass('d-none')
    $(this).closest('.contact_person_quality_controls_rows').find('.row').not('.d-none').last().find('.hr').addClass('d-none')
  })

  $('#offcanvasRight').on('change', '#quality_control_qc_type', function(event) {
    if ($(this).val() === 'SOITTO' || $(this).val() === 'ULKOINEN') {
      $('.quality-control-contact-people').removeClass('d-none')
      $('.quality-control-cleaning-closet').addClass('d-none')
    } else {
      $('.quality-control-remove-record:visible').each(function() {
        $(this).click()
      })
      $('.quality-control-contact-people').addClass('d-none')
      $('.quality-control-cleaning-closet').removeClass('d-none')
    }
    if ($(this).val() === 'ALOITUS') {
      $('#quality_control_next_check_date').prop("disabled", true)
    } else {
      $('#quality_control_next_check_date').prop("disabled", false)
    }
  })

  $('#offcanvasRight').on('change', '.quality_control_select_customer_contact_person', function(event) {
    const id = $(this).val()
    let firstSelectId = null
    if ($(this).hasClass('laatu')) {
      $(this).closest('.contact_person').find('input[name*="contact_person_id"]').val(id)
      firstSelectId = $('.contact_person:visible:first select:first').attr('id')
    } else {
      $(this).closest('.contact_person_quality_controls_row').find('input[name*="contact_person_id"]').val(id)
      firstSelectId = $('.contact_person_quality_controls_row .contact_person:visible:first select:first').attr('id')
    }

    const $cp = $(this).closest('.contact_person')
    if (id) {
      $(this).closest('.contact_person_quality_controls_row').find('input[name*="contact_person_id"]').val(id)
      lockButton(event.currentTarget)

      const customerId = $("#mainForm").attr('action').split('/')[2]
      request.get(`/customers/${customerId}/contact_people/${id}`)
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          $cp.find('input[name*="first_name"]').val(res.body.first_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="last_name"]').val(res.body.last_name).prop("disabled", res.body.deleted)
          $cp.find('input[name*="phone"]').val(res.body.phone).prop("disabled", res.body.deleted)
          $cp.find('input[name*="email"]').val(res.body.email).prop("disabled", res.body.deleted)
          $cp.find('input[name*="title"]').val(res.body.title).prop("disabled", res.body.deleted)

          if (firstSelectId === $(this).attr('id')) {
            $('#quality_control_contact_name').text(res.body.first_name + ' ' + res.body.last_name)
          }

          unlockButton(event.currentTarget)
        })
        .catch(err => {
          handleErrors(err, event.currentTarget)
        })
    } else {
      $cp.find('input[name*="first_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="last_name"]').val('').prop("disabled", false)
      $cp.find('input[name*="phone"]').val('').prop("disabled", false)
      $cp.find('input[name*="email"]').val('').prop("disabled", false)
      $cp.find('input[name*="title"]').val('').prop("disabled", false)

      if (firstSelectId === $(this).attr('id')) {
        $('#quality_control_contact_name').html('')
      }
    }
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    if ($("#mainForm").length && $("#mainForm").attr('action').includes('quality_controls')) {
      $(this).blur()
      lockButton('#confirmDelete')

      // T-111: `deleteRecord` clears `dirty`; same reason as the customer delete, which also navigates.
      deleteRecord($("#mainForm").attr('action'), { accept: 'text/javascript' })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })
}
